import { useSession } from "session";
import { Link } from "react-router-dom";
import { dueTone, registrationLine } from "service/business";
import { linkButton } from "pages/ApplicationReview/styles";
import { DueChip } from "./StatusChip";
import { isWaiting, useApplications } from "./useApplications";

/** Home: what is waiting for review, with the way in to register a business. */
export function ApplicationsCard() {
  const { can } = useSession();
  const allowed = can("business.create") || can("business.review");
  const { data, isLoading, isError, refetch } = useApplications(allowed);
  if (!allowed) return null;

  const waiting = (data ?? []).filter(isWaiting);
  const shown = waiting.slice(0, 3);

  return (
    <div className="w-full flex flex-col bg-white-A700 rounded-xl">
      <div className="p-4 border-b flex w-full justify-between items-center text-sm font-semibold text-[#333333]">
        <span>Applications to review</span>
        <Link to="/corporateregistration/business" className="sm:w-auto">
          <button
            type="button"
            className="rounded-lg py-2 px-3 bg-blue-700 text-white-A700 font-semibold text-sm cursor-pointer hover:bg-blue-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-700"
          >
            Register a business
          </button>
        </Link>
      </div>
      <div className="p-4 text-sm">
        {isError && (
          <p role="alert">
            Couldn&apos;t load applications.{" "}
            <button type="button" className={linkButton} onClick={() => refetch()}>
              Retry
            </button>
          </p>
        )}
        {isLoading && (
          <div className="flex flex-col gap-3" aria-busy="true" aria-label="Loading applications">
            {[0, 1, 2].map((i) => (
              <div key={i} className="h-10 rounded-md bg-gray-100 animate-pulse" />
            ))}
          </div>
        )}
        {!isLoading && !isError && waiting.length === 0 && (
          <p>No applications waiting for review.</p>
        )}
        {!isLoading && !isError && shown.length > 0 && (
          <ul className="flex flex-col divide-y">
            {shown.map((b) => {
              const tone = dueTone(b.oldestDueAt);
              return (
                <li key={b.id}>
                  <Link
                    to={`/applications/${b.id}`}
                    className="flex items-center justify-between gap-3 py-3 px-2 rounded-md cursor-pointer hover:bg-[#E1EBFC] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-700"
                  >
                    <span className="flex flex-col min-w-0">
                      <span className="font-semibold truncate">{b.legalName}</span>
                      <span className="text-xs text-[#6B7280]">
                        {registrationLine(b)}
                      </span>
                    </span>
                    <span className="flex items-center gap-3 shrink-0">
                      {tone && <DueChip tone={tone} />}
                      <span className="font-semibold text-blue-700">Open</span>
                    </span>
                  </Link>
                </li>
              );
            })}
          </ul>
        )}
        {!isLoading && !isError && waiting.length > 0 && (
          <Link
            to="/lead/contacts/corporate?tab=applications"
            className={`${linkButton} inline-block mt-2`}
          >
            View all in Applications ({waiting.length})
          </Link>
        )}
      </div>
    </div>
  );
}
